import { Component } from '@angular/core';
import { Deposito } from '../../../../types/Deposito.type';
import { DepositosService } from './depositos.service';
import { ToastService } from '../../../../services/toast.service';

@Component({
  selector: 'app-depositos',
  templateUrl: './depositos.component.html',
  styleUrl: './depositos.component.css'
})
export class DepositosComponent {

  depositos: Deposito[] = []

  loading: boolean = false;
  loadingSincronizar: boolean = false;

  constructor(private depositosService: DepositosService, private toastService: ToastService){
    this.getAll()
  }

  getAll(){
    this.loading = true;
    this.depositosService.getAll().subscribe({
      next: (data) => { this.depositos = data; this.loading = false; },
      error: (value) => { console.error(value); this.loading = false }
    })
  }

  exportar(){
    this.loadingSincronizar = true;

    this.depositosService
      .exportar()
      .subscribe({
        next: (value) => {
          const url = window.URL.createObjectURL(value);
          const a = document.createElement('a')
          a.href = url
          a.download = 'depositos.xlsx'
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        },
        error: (error) => {
          this.toastService.erro("Exportar", 'Erro ao exportar:' + (error?.error ?? error));
          this.loadingSincronizar = false;
        },
        complete: () => {
          this.loadingSincronizar = false;
        },
      });
  }
}
